import { render, staticRenderFns } from "./DialogTranferInput.vue?vue&type=template&id=d1685876"
import script from "./DialogTranferInput.vue?vue&type=script&lang=js"
export * from "./DialogTranferInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports